(() => {
  const ROOT_SELECTOR = '.product-form[data-template]';

  function textFor(el) {
    if (!el) return '';
    const className = typeof el.className === 'string' ? el.className : '';
    return [
      el.textContent || '',
      el.getAttribute && (el.getAttribute('aria-label') || ''),
      className
    ].join(' ');
  }

  function findWishlistControl(section, proxy) {
    const controls = section.querySelectorAll('button, a, [role="button"]');
    return Array.from(controls).find((el) => {
      if (el === proxy || el.classList.contains('lmp-wishlist-heart')) return false;
      return /wishlist|favori/i.test(textFor(el));
    }) || null;
  }

  function hideOriginalWishlist(control) {
    if (!control) return;
    const wrapper =
      control.closest('.Vtl-WishlistButtonWrapper') ||
      control.closest('[class*="Vtl-WishlistButtonWrapper"]') ||
      control.closest('[class*="Vtl-WishlistButton"]') ||
      control;
    wrapper.classList.add('lmp-original-wishlist-hidden');
  }

  function setupWishlist(section, proxy) {
    let activeControl = null;
    let controlObserver = null;

    const sync = () => {
      if (!activeControl) return;
      const pressed =
        activeControl.getAttribute('aria-pressed') === 'true' ||
        activeControl.classList.contains('active') ||
        activeControl.classList.contains('is-active') ||
        /remove|retirer/i.test(textFor(activeControl));
      proxy.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      proxy.setAttribute(
        'aria-label',
        pressed ? 'Retirer ce produit des favoris' : 'Ajouter ce produit aux favoris'
      );
    };

    const bind = () => {
      const control = findWishlistControl(section, proxy);
      if (!control) return false;
      if (control === activeControl) {
        hideOriginalWishlist(control);
        sync();
        return true;
      }

      activeControl = control;
      hideOriginalWishlist(control);

      if (controlObserver) controlObserver.disconnect();
      controlObserver = new MutationObserver(sync);
      controlObserver.observe(control, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
      });

      proxy.onclick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (activeControl) {
          activeControl.click();
          window.setTimeout(sync, 80);
          window.setTimeout(sync, 350);
        }
      };

      sync();
      return true;
    };

    if (bind()) return;

    const observer = new MutationObserver(() => {
      if (bind()) observer.disconnect();
    });
    observer.observe(section, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 12000);
  }

  function setup(root) {
    if (!root || root.querySelector(':scope > .lmp-purchase-row')) return;

    const quantity = root.querySelector(':scope > .product-quantity');
    const addToCart = root.querySelector(':scope > .product-add-to-cart');
    if (!quantity || !addToCart) return;

    const row = document.createElement('div');
    row.className = 'lmp-purchase-row';
    root.insertBefore(row, quantity);
    row.appendChild(quantity);
    row.appendChild(addToCart);

    const wishlist = document.createElement('button');
    wishlist.type = 'button';
    wishlist.className = 'lmp-wishlist-heart';
    wishlist.setAttribute('aria-label', 'Ajouter ce produit aux favoris');
    wishlist.setAttribute('aria-pressed', 'false');
    wishlist.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    row.appendChild(wishlist);

    setupWishlist(root.closest('.product-section') || root, wishlist);
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
